import { render, staticRenderFns } from "./blacklistManage.vue?vue&type=template&id=1880f328&scoped=true&"
import script from "./blacklistManage.vue?vue&type=script&lang=js&"
export * from "./blacklistManage.vue?vue&type=script&lang=js&"
import style0 from "./blacklistManage.vue?vue&type=style&index=0&id=1880f328&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880f328",
  null
  
)

export default component.exports